import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeStatusComponent } from '../../../../../shared/components/alert-status/badge-status.component';
import { BadgeComponent } from '../../../../../shared/components/badge/badge.component';
import { ProductViewData } from '../../admin-product-view.model';

@Component({
  selector: 'app-product-details-section',
  standalone: true,
  imports: [CommonModule, BadgeStatusComponent, BadgeComponent],
  templateUrl: './product-details-section.component.html',
})
export class ProductDetailsSectionComponent {
  @Input({ required: true }) product!: ProductViewData;

  getProductLink(): string | null {
    const p = this.product;
    if (!p?.linkId) return null;
    return `https://site.fastshop.com.br/${p.linkId}/p`;
  }

  getAdminLink(): string | null {
    const p = this.product;
    if (!p?.productId) return null;
    return `https://fastshopbr.myvtex.com/admin/catalog-products/product/${p.productId}`;
  }

  isSpecialConditionProduct() {
    if (!this.product) return false;
    if (!this.product.stores) return true;
    return this.product.stores.some(x => x.storeId === 43) ?? false;
  }

  allSkusHasImages() {
    return this.product?.skus.every(x => (x.images?.length ?? 0) > 0);
  }

  isProductVisible() {
    return this.product?.isVisible ?? false;
  }

  isProductActive() {
    return this.product?.isActive ?? false;
  }

  productHasNoPrice() {
    return this.product?.skus.every(x => !x.skuPrices);
  }

  productHasSkuWithNoPrices() {
    return this.product?.skus.some(p => !p.skuPrices) ?? true;
  }

  isMarketplaceProduct(): boolean {
    return this.product?.isMarketplace || false;
  }
}
